import { COMMON_SETTINGS } from "./commonWidgetSettings";

export const PRECALL_SETTINGS = [
  { ...COMMON_SETTINGS.COWORKER, additionalControl: { defaultCoworker: true } },
  COMMON_SETTINGS.STORE,
];
